import React from 'react';
import { useEffect, useState } from "react";
import { useParams, matchPath } from "react-router-dom";

import Funding from '../onboarding/application/components/Funding';
import MerchantStateContextProvider from '../onboarding/application/context/MerchantStateContext';
import ReviewSignature from '../onboarding/application/components/signatureReview/ReviewSignature ';
import GenericUpload from "../onboarding/application/components/GenericUploadComponent/GenericUpload";
import PageNotFound from "../onboarding/application/components/404Page";

import QueryString from 'query-string';
import config from '../../config';


const routes = [
  { path: '/onboarding/merchant/', component: (props) => <MerchantStateContextProvider><Funding {...props} /></MerchantStateContextProvider> },
  { path: '/onboarding/merchant/:accountUuid/reviewsignature/:contactUuid/:opportunityUuid', component: ReviewSignature },
  { path: '/onboarding/merchant/:accountUuid/genericUpload/:contactUuid/:opportunityUuid', component: GenericUpload },
];

const matchComponent = (originalUrl) => {
  const parsedUrl = new URL(originalUrl);
  const path = parsedUrl.pathname;
  const searchParams = QueryString.parse(parsedUrl.search);

  let matchedRoute;
  let match;
  for (const route of routes) {
    match = matchPath(path, { path: route.path, exact: true });
    if (match) {
      matchedRoute = {...match, component: route.component};
      break;
    }
  }

  const { component, params } = matchedRoute || {};

  return {
    path: path,
    component,
    props: {
      passed: { state: { params, searchQuery: searchParams } },
    },
  };

}


const ShortUrlResolver = (props) => {
    const { hash } = useParams();

    const [matchedComponent, setMatchedComponent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const fetchOriginalUrl = async () => {
            try {
                const response = await fetch(`${config.apiUrl}/api/uplyftOnboarding/a/${hash}`);
                if(!response.ok) {
                    throw new Error(`API Error : ${response?.status} - ${response?.statusText}`);
                }

                const data = await response.json();
                if(isMounted) {
                    const component = matchComponent(data.originalUrl);
                    setMatchedComponent(component);
                }
            } catch (error) {
                if(isMounted) {
                    setError(error.message);
                }
            } finally {
                if(isMounted) {
                    if(isMounted) {
                        setLoading(false);
                    }
                }
            }
        }

        fetchOriginalUrl();
        
        return () => {
            isMounted = false;
        }
    }, [hash]);

    if(loading) {
      return <div className='spinner'><div className='loader'>submitting...</div></div>
    }

    if(error) {
      return <PageNotFound />;
    }

    if(matchedComponent) {
      const {component: Component, path, props: componentProps} = matchedComponent;

      if(path === '/onboarding/merchant') {
        return (
          <MerchantStateContextProvider>
            <Funding {...props} {...componentProps} />
          </MerchantStateContextProvider>
        )
      } 
      else if(path.includes('reviewsignature')) {
        return <ReviewSignature {...props} {...componentProps} />
      } 
      else if(path.includes('genericUpload')) {
        return <GenericUpload {...props} {...componentProps} />
      }
    }

    return null;
};

export default ShortUrlResolver;